import React, { useState, useEffect } from 'react';
import MasterTable from "../common/MasterTable";
import SellSMSModal from '../sellsms/SellSMSModal';
import { axiosPostApi } from '../../helpers/interceptorServices';
import { apiList } from '../../helpers/apiList';
import CustomAlert from '../../helpers/CustomAlert';
import Loader from '../Loader/Loader';

const SellSMS = () => {
  const loggedInUserName = sessionStorage.getItem('username');
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [sellSMSData, setSellSMSData] = useState([]);
  const [modalAction, setModalAction] = useState('');
  const [loading, setLoading] = useState(true);
  const [pageDetails, setPageDetails] = useState(null);
  const [pageSize, setPageSize] = useState(10)
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    fetchSellSMSData(1);
  }, []);

  const fetchSellSMSData = async (currentPage) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        status: ""
      };


      const response = await axiosPostApi(
        `${apiList.FETCH_SELLSMS_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );
      if (response?.data?.status === true && response?.data?.respCode === "00") {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setSellSMSData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setSellSMSData([]);
        // if (response?.data?.data !== null || response?.data?.respCode === "02") {
        //   CustomAlert({
        //     title: "No Data",
        //     text: response?.data?.message || "No data available for the specified criteria.",
        //     icon: 'info',
        //     confirmButtonText: 'Okay'
        //   });
        // }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry"
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      transactionDate: item.transactionDate?.split(" ")?.[0],
      id: index + 1,
    }));
  };

  const sellSMSHeaders = [
    "Status",
    "Customer Id",
    "Customer Name",
    "Transaction Id",
    "TxnType",
    "Transaction Date",
    "Sms",
    "Customer Old Sms",
    "Customer New Sms",
    "Rate",
    "Amount"
  ];

  const sellSMSHeaderToKeyMap = {
    "Status": "status",
    "Customer Id": "customerId",
    "Customer Name": "customerName",
    "Transaction Id": "rrn",
    "TxnType": "txnType",
    "Transaction Date": "transactionDate",
    "Sms": "sms",
    "Customer Old Sms": "customerOldSms",
    "Customer New Sms": "customerNewSms",
    "Rate": "rate",
    "Amount": "amount"
  }

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction('');
  };

  const handlerSellSMS = (id, actionType = 'view') => {
    setModalAction(actionType);
    if (actionType === 'add') {
      setEditData({});
      setShowModal(true);
    } else {
      let data = sellSMSData.find((item) => item.id === id);
      setEditData(data);
      setShowModal(true);
    }
  };

const pageSizeCount = pageDetails === null  ? 0 : pageDetails.pageSize;
const totalRecord = pageDetails === null  ? 0 : pageDetails.totalRecords;

  return (
    <div>
       {loading ?
      <Loader/>: 
        <>
      <MasterTable
        headers={sellSMSHeaders}
        data={sellSMSData}
        handleAction={handlerSellSMS}
        filterFields={['customerName']}
        entityType="Top-up SMS"
        headerToKeyMap={sellSMSHeaderToKeyMap}
        loading={loading}
        pageDetails={pageDetails}
        noData={noData}
        currentPage={currentPage}
        pageSize={pageSizeCount}
        totalRecord={totalRecord}
        fetchNextData={fetchSellSMSData}
        setCurrentPage={setCurrentPage}
      />
      <SellSMSModal
        show={showModal}
        handleClose={handleCloseModal}
        editData={editData}
        action={modalAction}
        data={sellSMSData}
        fetchData={fetchSellSMSData}
      />
       </>}
    </div>
  )
}

export default SellSMS